export function BrandMark() {
  return (
    <svg
      className="brand-mark"
      viewBox="0 0 54 36"
      role="img"
      aria-label=""
      focusable="false"
    >
      <defs>
        <linearGradient id="wendo-brand" x1="2" y1="4" x2="50" y2="31">
          <stop stopColor="#845cff" />
          <stop offset="1" stopColor="#4c25d4" />
        </linearGradient>
      </defs>
      <path
        d="M4.8 5.4a5.1 5.1 0 0 1 9.6.3l4.3 15.1 4.4-15a5 5 0 0 1 9.5-.2l4.8 15.2 4-14.9a5 5 0 1 1 9.7 2.6l-7.9 23.1a5.8 5.8 0 0 1-11 .1L28 18.5l-4.1 13.1a5.8 5.8 0 0 1-11-.1L4.5 8.4a5 5 0 0 1 .3-3Z"
        fill="url(#wendo-brand)"
      />
    </svg>
  );
}
